import axios from 'axios'
import router from '@/router'
import common from './common'
import { publicIpv4 } from 'public-ip'

// initial state
const state = {
  sessionTimeout: '',
  sessionId: null,
  activeSessionTimeout: null,
  fbToken: null,
  ipUser: null,
  latitude: null,
  longitude: null,
  place: null,
  imageMapPlace: null,
  deviceInfoReady: false
}

// getters
const getters = {
  getSessionLocalStorage() {
    let sessionFlagship = localStorage.getItem('sessionFlagship')
    let jsonSessionFlagship = JSON.parse(sessionFlagship)
    if (
      !jsonSessionFlagship ||
      !jsonSessionFlagship.expiry ||
      jsonSessionFlagship.expiry < Date.now()
    ) {
      sessionFlagship = JSON.stringify({
        data: {
          sessionId: null,
          ipUser: null,
          latitude: null,
          longitude: null,
          deviceId: null,
          deviceLanguageCode: null,
          place: null,
          imageMapPlace: null
        },
        expiry: null
      })
    }

    let sesionFlagshipParse = JSON.parse(sessionFlagship)

    if (sesionFlagshipParse.data.sessionId) {
      let userPlatform = JSON.parse(localStorage.getItem('userPlatform'))
      userPlatform.sessionId = sesionFlagshipParse.data.sessionId
      const updatedUserPlatform = JSON.stringify(userPlatform)
      localStorage.setItem('userPlatform', updatedUserPlatform)
    }

    return sesionFlagshipParse
  },
  getPlace(state) {
    return state.place
  },
  getFbToken(state) {
    return state.fbToken
  },
  getImageMapPlace(state) {
    return state.imageMapPlace
  },
  getDeviceInfoReady(state) {
    return state.deviceInfoReady
  }
}

// actions
const actions = {
  async createSession({ dispatch, commit, rootState }) {
    try {
      await dispatch('restorePreviousSessionIfActive')
      if (!state.sessionId) {
        const url = process.env.VUE_APP_PATH + 'createAnonymousSession'
        const response = await axios.post(url, null, {
          params: {
            deviceId: rootState.common.deviceId
          }
        })
        dispatch('updateSessionId', response.data.sessionId)
      }
      commit('setSessionTimeout', process.env.VUE_APP_TIMEOUT_INACTIVITY)
      dispatch('resetSessionTimeout')
      dispatch('updateIpAndGeolocation')

      return true
    } catch (error) {
      console.error(error)
      return error
    }
  },
  async endSession({ commit, state, rootState, dispatch }) {
    if (state.sessionId) {
      try {
        clearTimeout(state.activeSessionTimeout)
        const url = process.env.VUE_APP_PATH + 'endAnonymousSession'
        await axios.post(url, {
          sessionId: state.sessionId,
          deviceId: rootState.common.deviceId
        })
        commit('setSessionTimeout', '')
        dispatch('updateSessionId', null)
        commit('setActiveSessionTimeout', null)
        commit('setIpUser', null)
        commit('setLatitude', null)
        commit('setLongitude', null)
        dispatch('updateDeviceId', null)
        dispatch('updateDeviceLanguageCode', null)
        commit('setPlace', null)
        commit('setImageMapPlace', null)

        localStorage.removeItem('sessionFlagship')
      } catch (error) {
        console.error(error)
        return error
      }
    }
  },
  startSessionTimeout({ dispatch, state, commit }) {
    let timeout = state.sessionTimeout
    if (timeout && timeout != '0') {
      clearTimeout(state.activeSessionTimeout)
      commit(
        'setActiveSessionTimeout',
        setTimeout(function () {
          dispatch('registerNavigation', {
            action: 'SESION_CADUCADA',
            name: 'Sesión caducada por inactividad'
          }).then(() => {
            setTimeout(() => {
              dispatch('endSession')
            }, 2000)
          })
        }, timeout)
      )
    }
  },
  resetSessionTimeout({ dispatch }) {
    dispatch('startSessionTimeout')
    dispatch('updateExpireSessionLocalStorage')
  },
  updateExpireSessionLocalStorage() {
    let jsonSessionFlagship = getters.getSessionLocalStorage()
    jsonSessionFlagship.expiry =
      Date.now() + 1 * process.env.VUE_APP_TIMEOUT_INACTIVITY

    localStorage.setItem('sessionFlagship', JSON.stringify(jsonSessionFlagship))
  },
  updateFieldsSessionLocalStorage(fieldName, value) {
    actions.updateExpireSessionLocalStorage()
    let jsonSessionFlagship = getters.getSessionLocalStorage()

    if (jsonSessionFlagship) {
      switch (fieldName) {
        case 'sessionId':
          jsonSessionFlagship.data.sessionId = value
          break
        case 'ipUser':
          jsonSessionFlagship.data.ipUser = value
          break
        case 'latitude':
          jsonSessionFlagship.data.latitude = value
          break
        case 'longitude':
          jsonSessionFlagship.data.longitude = value
          break
        case 'deviceId':
          jsonSessionFlagship.data.deviceId = value
          break
        case 'deviceLanguageCode':
          jsonSessionFlagship.data.deviceLanguageCode = value
          break
        case 'place':
          jsonSessionFlagship.data.place = value
          break
        case 'imageMapPlace':
          jsonSessionFlagship.data.imageMapPlace = value
          break
        default:
          break
      }

      localStorage.setItem(
        'sessionFlagship',
        JSON.stringify(jsonSessionFlagship)
      )
    }
  },
  restorePreviousSessionIfActive({ commit, dispatch }) {
    let jsonSessionFlagship = JSON.parse(
      localStorage.getItem('sessionFlagship')
    )

    console.log('*** restorePreviousSessionIfActive ***')
    console.log(jsonSessionFlagship)
    console.log(jsonSessionFlagship.expiry > Date.now())

    if (
      jsonSessionFlagship &&
      jsonSessionFlagship.data &&
      jsonSessionFlagship.data.sessionId &&
      jsonSessionFlagship.expiry > Date.now()
    ) {
      console.log('*** restorePreviousSessionIfActive ***')
      console.log('*** updating ***')

      dispatch('updateSessionId', jsonSessionFlagship.data.sessionId)
      dispatch('updateDeviceId', jsonSessionFlagship.data.deviceId)
      dispatch(
        'updateDeviceLanguageCode',
        jsonSessionFlagship.data.deviceLanguageCode
      )
      commit('setIpUser', jsonSessionFlagship.data.ipUser)
      commit('setLatitude', jsonSessionFlagship.data.latitude)
      commit('setLongitude', jsonSessionFlagship.data.longitude)
      commit('setPlace', jsonSessionFlagship.data.place)
      commit('setImageMapPlace', jsonSessionFlagship.data.imageMapPlace)
    }
  },
  async getLocationIP({ commit }) {
    let lat, lon
    try {
      const url =
        process.env.VUE_APP_URL_LOCATION_URL +
        state.ipUser +
        '?fields=lat,lon' +
        '&key=' +
        process.env.VUE_APP_URL_LOCATION_KEY
      const response = await axios.get(url, null)
      lat = response.data.lat
      lon = response.data.lon
    } catch (error) {
      console.log('Error obtaining location by IP', error.message)
      // Mientras la version para obtener location por ip sea la freemium, en caso de error por cors
      // para entorno DEV seteamos longitud y latitud por defecto del dispositivo
      if (process.env.VUE_APP_MODE_DEV == 'true') {
        lat = common.state.deviceLatitude
        lon = common.state.deviceLongitude
      }
    }
    commit('setLatitude', lat)
    commit('setLongitude', lon)
  },
  async updateIpAndGeolocation({ commit, dispatch }) {
    let jsonSessionFlagship = getters.getSessionLocalStorage()
    if (state.sessionId && jsonSessionFlagship.expiry > Date.now()) {
      let v_ipUser = await publicIpv4()
      commit('setIpUser', v_ipUser)
      dispatch('getLocationIP')
    } else {
      commit('setIpUser', null)
      commit('setLatitude', null)
      commit('setLongitude', null)
    }
  },
  updatePlace({ commit }, value) {
    commit('setPlace', value)
    actions.updateFieldsSessionLocalStorage('place', value)
  },
  updateSessionId({ commit }, value) {
    commit('setSessionId', value)
    actions.updateFieldsSessionLocalStorage('sessionId', value)
  },
  async generateSessionLocalStorageAndLocation({ commit, dispatch }) {
    getters.getSessionLocalStorage()
    let v_ipUser = await publicIpv4()
    commit('setIpUser', v_ipUser)
    await dispatch('getLocationIP')
  }
}

// mutations
const mutations = {
  setSessionTimeout(state, value) {
    state.sessionTimeout = value
  },
  setSessionId(state, value) {
    state.sessionId = value
  },
  setActiveSessionTimeout(state, value) {
    state.activeSessionTimeout = value
  },
  setFbToken(state, value) {
    state.fbToken = value
  },
  setIpUser(state, value) {
    state.ipUser = value
    actions.updateFieldsSessionLocalStorage('ipUser', value)
  },
  setLatitude(state, value) {
    state.latitude = value
    actions.updateFieldsSessionLocalStorage('latitude', value)
  },
  setLongitude(state, value) {
    state.longitude = value
    actions.updateFieldsSessionLocalStorage('longitude', value)
  },
  setPlace(state, value) {
    state.place = value
    actions.updateFieldsSessionLocalStorage('place', value)
  },
  setImageMapPlace(state, value) {
    state.imageMapPlace = value
    actions.updateFieldsSessionLocalStorage('imageMapPlace', value)
  },
  setDeviceInfoReady(state, value) {
    state.deviceInfoReady = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
